import { render, staticRenderFns } from "./MyProgram.vue?vue&type=template&id=0caa2c26&scoped=true"
import script from "./MyProgram.vue?vue&type=script&lang=ts"
export * from "./MyProgram.vue?vue&type=script&lang=ts"
import style0 from "./MyProgram.vue?vue&type=style&index=0&id=0caa2c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa2c26",
  null
  
)

export default component.exports